import {nest, withProps,} from 'recompose'
import {DelayRender} from 'views/Discovery/DelayRender'
import {organizationPermissionCodes} from 'modules/permissions/contants'
import React, {useCallback, useContext, useMemo} from 'react'
import {createCheckPermissions,} from 'views/AppLocals/factory/createCheckPermissions'
import {SettingsMenu} from 'views/AppLocals/factory/createSettingLayout'
import DefaultTemplate from 'views/AppLocals/Templates/DefaultTemplate'
import {renderOwnChild} from 'views/Shared'
import CustomSiderMenu from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceContext from "../WorkspaceContext";
import useTranslate from "../../../modules/local/useTranslate";
import {PiMonitorLight, PiUsersFourLight, PiUsersThreeLight} from "react-icons/pi";
import WorkspaceMemberDashboard from "../Member/WorkspaceMemberDashboard";
import WorkspaceOrganizationMemberDetail from "../Member/WorkspaceOrganizationMemberDetail";
import WorkspaceOrgDeptContainer from "../Member/WorkspaceOrgDeptContainer";

const ItemKeys = Object.freeze({
    DASHBOARD: 'dashboard',
    MEMBERS: 'members',
    WAITING_MEMBERS: 'waiting-members',
    INVITES: 'invites',
    ORGANIZATION_MEMBERS: 'org-members',
    ORGANIZATION_MEMBERS_LIST: 'org-members-list',
    WAITING_ORGANIZATION_MEMBERS: 'waiting-org-members',
    ORGANIZATION_INVITES: 'org-invites',

    ORGANIZATION_DEPARTMENTS: 'org-departments',
});


export const DepartmentActionTypes = Object.freeze({
    DEPT_CREATE: 'dept-create',
    DEPT_UPDATE: 'dept-update',
    DEPT_DELETE: 'dept-delete',
    DEPT_ADD_MEMBER: 'dept-add-member',
    DEPT_ADD_ORG_MEMBER: 'dept-add-org-member',
    DEPT_EDIT_MEMBER: 'dept-edit-member',
    DEPT_DELETE_MEMBER: 'dept-delete-member',
    DEPT_MEMBER_SET_ACTIVE: 'dept-member-set-active',
})


const WorkspaceMemberContent = () => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext);
    const menuItems = useMemo(() => {
        const menuItems = [
            {
                key: ItemKeys.DASHBOARD,
                label: 'overview',
                icon: <PiMonitorLight size={16}/>,
            },
            {
                key: ItemKeys.ORGANIZATION_MEMBERS,
                label: 'members',
                icon: <PiUsersThreeLight size={16}/>,
            },
            {
                key: ItemKeys.ORGANIZATION_DEPARTMENTS,
                label: 'groups / ministries',
                icon: <PiUsersFourLight size={16}/>,
            },
        ]
        return menuItems;
    }, [])
    const routeEntities = useMemo(() => {
        const routeEntities = [
            {
                key: ItemKeys.DASHBOARD,
                component: WorkspaceMemberDashboard,
            },
            {
                key: ItemKeys.ORGANIZATION_MEMBERS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(WorkspaceOrganizationMemberDetail),
            },
            {
                key: ItemKeys.ORGANIZATION_DEPARTMENTS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(WorkspaceOrgDeptContainer),
            },
        ].map(({key, ...rest}) => ({
            key,
            path: key,
            ...rest,
        }))
        return routeEntities;
    }, [])

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    const renderMenu = useCallback(
        () => (
            <CustomSiderMenu
                deps={[activeKey]}
                Wrapper={renderOwnChild}>
                <SettingsMenu
                    items={menuItems}
                    onSelect={onMenuSelect}
                    selectedKeys={[activeKey]}
                    // defaultSelectedKeys={[activeKey]}
                    defaultOpenKeys={[]}
                />
            </CustomSiderMenu>
        ),
        [menuItems, activeKey]
    )

    return (
        <DefaultTemplate renderMenu={renderMenu}>
            <div className="space-y-3 p-2 222-222">
                <Component/>
            </div>
        </DefaultTemplate>
    )
}

export default nest(
    withProps({lazy: true})(
        DelayRender
    ),
    WorkspaceMemberContent
)
